import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectionStore from '../../../stores/ProjectionStore';
import NumberUtils from '../../../utils/NumberUtils';
import _ from 'lodash';

const getStateFromStores = () => {
  return {
    contents: ProjectionStore.getEarningsAndCommitments(),
  };
};

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work shoul consider refactoring or replacing this component
 * to improve the health of the codebase.
 */
class EarningAndCommitmentComponent extends Component {
  constructor(props) {
    super(props);

    this.getEarningsId = this.getEarningsId.bind(this);
    this.dateConversion = this.dateConversion.bind(this);
    this.earnings = this.earnings.bind(this);
    this.standingOrders = this.standingOrders.bind(this);
    this.directdebits = this.directdebits.bind(this);

    this.state = getStateFromStores();
  }

  getEarningsId(id, flag) {
    this.props.getEarningsId(id, flag);
  }

  dateConversion(value) {
    if (value !== '') {
      const monthName = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const fullDate = new Date(value);
      const day = fullDate.getDate();
      const month = fullDate.getMonth();
      const year = fullDate.getFullYear();
      const dateStr = `${`0${day}`.slice(-2)} ${monthName[month].substr(
        0,
        3
      )} ${year.toString().substr(2, 4)}`;
      return <label>{dateStr}</label>;
    }
  }

  earnings() {
    if (this.props.data.earnings !== undefined) {
      let earningsIds = ProjectionStore.getEarningId();
      let rowData = this.props.data.earnings.map((rows, keys) => {
        let date = rows.earningsLastKnownDate;
        let newDate;
        if (date === null || date === undefined) {
          newDate = '';
        } else {
          newDate = this.dateConversion(rows.earningsLastKnownDate);
        }
        let value = _.indexOf(earningsIds, rows.earningsId);
        const isEarnigsEnabled = value >= 0;
        return (
          <tr id={keys} key={rows.earningsId}>
            <td>
              <div className="option-select">
                <input
                  type="checkbox"
                  id={rows.earningsId}
                  name={rows.earningsName}
                  onChange={this.getEarningsId.bind(
                    this,
                    rows.earningsId,
                    rows.earningsEnabledFlag
                  )}
                  defaultValue={rows.earningsId}
                  value={isEarnigsEnabled}
                  checked={isEarnigsEnabled}
                />
                <label htmlFor={rows.earningsId} />
              </div>
              {rows.earningsName}
            </td>
            <td>{newDate}</td>
            <td>{rows.earningsFrequency}</td>
            <td>
              {NumberUtils.appendCurrency('{}', rows.earningsLastKnownAmount)}
            </td>
          </tr>
        );
      });
      return rowData;
    } else {
      return <tr>Loading .............................</tr>;
    }
  }

  standingOrders() {
    if (this.props.data.commitments !== undefined) {
      return this.props.data.commitments.map((rowData, i) => {
        let date = rowData.standingOrderLastKnownDate;
        let newDate;
        if (date === null || date === undefined) {
          newDate = '';
        } else {
          newDate = this.dateConversion(rowData.standingOrderLastKnownDate);
        }
        return (
          <tr key={rowData.id} id={i}>
            <td>{rowData.standingOrderName}</td>
            <td> {newDate} </td>
            <td>{rowData.standingOrderFrequency} </td>
            <td>
              {NumberUtils.appendCurrency(
                '{}',
                rowData.standingOrderLastKnownAmount
              )}
            </td>
          </tr>
        );
      });
    } else {
      return <tr>Loading .............................</tr>;
    }
  }

  directdebits() {
    if (this.props.data.directDebits !== undefined) {
      let directdebits = this.props.data.directDebits.map((rowData, i) => {
        let date = rowData.directDebitsLastKnownDate;
        let newDate;
        if (date === null || date === undefined) {
          newDate = '';
        } else {
          newDate = this.dateConversion(rowData.directDebitsLastKnownDate);
        }
        return (
          <tr key={rowData.id} id={i}>
            <td> {rowData.directDebitsName}</td>
            <td> {newDate} </td>
            <td> {rowData.directDebitsFrequency} </td>
            <td>
              {NumberUtils.appendCurrency(
                '{}',
                rowData.directDebitsLastKnownAmount
              )}
            </td>
          </tr>
        );
      });
      return directdebits;
    }
  }

  render() {
    return (
      <div className="settings-content-wrapper">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div id="earnings-tab-container" className="account-1">
                <p className="tab-header">
                  {
                    this.props.content
                      .projectionSettingsEarningsAndCommitmentsHeader
                  }
                </p>
                <table className="earnings-table1">
                  <tbody key="1">
                    <tr>
                      <th width="35%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsEarnings
                        }
                      </th>
                      <th width="15%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsLastKnown
                        }
                      </th>
                      <th width="25%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsFrequency
                        }
                      </th>
                      <th width="25%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsLastKnownAmount
                        }
                      </th>
                    </tr>
                    {this.earnings()}
                  </tbody>
                </table>
                <table className="earnings-table2">
                  <tbody key="2">
                    <tr>
                      <th width="35%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsStandingOrders
                        }
                      </th>
                      <th width="15%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsLastKnown
                        }
                      </th>
                      <th width="25%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsFrequency
                        }
                      </th>
                      <th width="25%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsLastKnownAmount
                        }
                      </th>
                    </tr>
                    {this.standingOrders()}
                  </tbody>
                </table>
                <table className="earnings-table3">
                  <tbody key="3">
                    <tr>
                      <th width="35%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsDirectDebits
                        }
                      </th>
                      <th width="15%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsLastKnown
                        }
                      </th>
                      <th width="25%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsFrequency
                        }
                      </th>
                      <th width="25%">
                        {
                          this.props.content
                            .projectionSettingsEarningsAndCommitmentsLastKnownAmount
                        }
                      </th>
                    </tr>
                    {this.directdebits()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EarningAndCommitmentComponent.propTypes = {
  getEarningsId: PropTypes.func,
  data: PropTypes.object,
  content: PropTypes.object,
};

export { EarningAndCommitmentComponent };
